"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SketchWidget = void 0;
const GraphicsLayer_1 = __importDefault(require("@arcgis/core/layers/GraphicsLayer"));
const SketchViewModel_1 = __importDefault(require("@arcgis/core/widgets/Sketch/SketchViewModel"));
class SketchWidget {
    constructor(sketchWidgetObject) {
        this.graphicsLayer = new GraphicsLayer_1.default();
        this.sketchWidget = new SketchViewModel_1.default();
        this.sketchWidgetObject = sketchWidgetObject;
        this.init();
    }
    init() {
        const { view, updateCallback, addCallback } = this.sketchWidgetObject;
        const graphicsLayer = this.graphicsLayer;
        view.map.add(graphicsLayer);
        const sketchWidget = new SketchViewModel_1.default({
            view: view,
            layer: graphicsLayer,
        });
        this.sketchWidget = sketchWidget;
        this.sketchWidget.on("update", (event) => {
            if (event.toolEventInfo &&
                event.toolEventInfo.type.endsWith("-stop")) {
                const promise = updateCallback(event.graphics[0]);
                promise.then((event) => {
                    console.log("FINISH", event);
                });
            }
            // user is clicking on the view... call update method with the center and edge graphics
            if (event.state === "complete" && !event.aborted) {
                graphicsLayer.removeAll();
            }
        });
        this.sketchWidget.on("create", function (event) {
            if (event.state === "complete") {
                console.log("Create complete", event);
                const promise = addCallback(event.graphic);
                promise.then((event) => {
                    console.log("FINISH", event);
                    graphicsLayer.removeAll();
                });
            }
        });
    }
    updateFeature(graphic) {
        //TODO remove this line (for the moment help to test)
        // @ts-ignore: Unreachable code error
        graphic["entsoeLayer"] = graphic.layer;
        this.graphicsLayer.graphics.add(graphic);
        this.sketchWidget.update(graphic);
    }
    createFeature(type) {
        this.sketchWidget.create(type);
    }
}
exports.SketchWidget = SketchWidget;
